const menuLinks = () => {
  return [
    {
      name: 'Company',
      eventKey: 1,
      routes: [
        { name: 'Media Kit', ref: 'mediakit', route: '/company/mediakit' }
      ]
    },
    {
      name: 'Researcher',
      eventKey: 2,
      routes: [
        { name: 'Example Results', target: '_blank', url: 'https://www.pollfish.com/dashboard/results/253227526/618845688' },
        { name: 'Case Studies', target: '_blank', url: 'http://blog.pollfish.com/category/market-research' }
      ]
    },
    {
      name: 'Respondent',
      eventKey: 3,
      routes: [
        { name: 'Opt Out', ref: 'opt-out', route: '/respondent/opt-out' }
      ]
    },
    {
      name: 'Terms of Service',
      eventKey: 4,
      routes: [
        { name: 'Researcher', ref: 'termsResearcher', route: '/terms/researcher' },
        { name: 'Subscription Plans', ref: 'termsSubscriptionPlans', route: '/terms/subscriptions' },
        { name: 'Researcher - Distribution Link', ref: 'termsResearcherLink', route: '/terms/researcher-link' },
        { name: 'Respondent', ref: 'termsRespondent', route: '/terms/respondent' },
        { name: 'Respondent - Distribution Link', ref: 'termsRespondentLink', route: '/terms/respondent-link' },
        { name: 'Cookie Policy', ref: 'cookiePolicy', route: '/terms/cookie-policy' }
      ]
    }
  ];
};

export default menuLinks;

